export default __webpack_public_path__ + "static/media/MattCutts_2011U.5affecce.wav";